import { render, staticRenderFns } from "./StartScan.vue?vue&type=template&id=5419a5f9&scoped=true&"
import script from "./StartScan.vue?vue&type=script&lang=js&"
export * from "./StartScan.vue?vue&type=script&lang=js&"
import style0 from "./StartScan.vue?vue&type=style&index=0&id=5419a5f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419a5f9",
  null
  
)

export default component.exports